import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Loader } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";
import { ProductCard } from "../components/ProductCard";
import { ChevronLeft } from "lucide-react";

export default function Browse() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [interests, setInterests] = useState(null);
  const [products, setProducts] = useState([]);
  const isRoot = id === "root";
  const currentId = isRoot ? null : id;

  useEffect(() => {
    (async () => {
      try { setInterests(await api("/interests")); } catch { setInterests([]); }
      if (currentId) {
        try { setProducts(await api(`/products/feed?interest_id=${currentId}`)); } catch {}
      } else { setProducts([]); }
    })();
  }, [id]); // eslint-disable-line

  if (!interests) return <Loader />;
  const current = interests.find((i) => i.interest_id === currentId);
  const children = interests.filter((i) => (isRoot ? !i.parent_id : i.parent_id === currentId));
  const title = isRoot ? "تصفّح الاهتمامات" : current?.name || "تصفّح";

  return (
    <div className="animate-fade-in-up max-w-5xl mx-auto">
      <PageHeader title={title} />
      {children.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-6">
          {children.map((c) => {
            const hasKids = interests.some((x) => x.parent_id === c.interest_id);
            return (
              <button key={c.interest_id} data-testid={`browse-${c.interest_id}`} onClick={() => navigate(`/browse/${c.interest_id}?type=interest`)} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-[#E8EAF2] hover:brand-shadow-sm text-start">
                <span className="w-3 h-3 rounded-full" style={{ backgroundColor: c.color || "#FF3D5A" }} />
                <span className="flex-1 font-bold text-[#161629]">{c.name}</span>
                {hasKids && <ChevronLeft size={16} className="text-[#9CA3AF]" />}
              </button>
            );
          })}
        </div>
      )}
      {products.length > 0 && (
        <>
          <h2 className="font-black text-[#161629] mb-3">المنتجات ({products.length})</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {products.map((p) => <ProductCard key={p.product_id} item={p} promoted={!!p.is_promoted} />)}
          </div>
        </>
      )}
    </div>
  );
}
